export const useLog = (domain, message, severity = 'D') => {
  const baseStyle = 'font-family: monospace;';
  const domainStyle =
    'background: #3CA091; color: white; padding: 8px; border-radius: 9999px; font-weight: bold;';

  /* eslint-disable id-length */
  const messageStyle = {
    D: 'color: #4B78F0;',
    S: 'color: #00A05F;',
    W: 'color: #FFAA32;',
    E: 'color: #FF5050;'
  }[severity];
  const severityEmoji = {
    D: 'ℹ️',
    S: '✅',
    W: '⚠️',
    E: '❌'
  }[severity];
  /* eslint-enable */

  console.log(
    `%c[${domain}]%c ${severityEmoji} ${message}`,
    `${baseStyle} ${domainStyle}`,
    `${baseStyle} ${messageStyle}`
  );
};
